<template>
  <div class="after-sale-item">
    <div
      class="item"
      @click="
        $router.push({ name: 'StoreAftSaleDetail', query: { id: source.id } })
      "
    >
      <div class="head van-hairline--bottom">订单号：{{ source.orderNo }}</div>
      <div class="body">
        <!-- 只有一个图片的 -->
        <div v-if="source.orderItems.length === 1" style="width:100%">
          <div
            v-for="(item, index) in source.orderItems"
            :key="source.id + index"
            class="flex flex-row mb-3 items-center"
          >
            <!-- //左侧图片 -->
            <div
              class="flex-shrink-0 flex-grow-0 rounded-md overflow-hidden"
              style="height: 66px; width: 66px; "
            >
              <img class="w-full h-full" :src="item.imgUrl" alt="" />
            </div>
            <!-- 列表内容 -->
            <div
              class="flex-grow flex flex-col ml-2 text-left justify-between "
              style="height: 66px; "
            >
              <div
                class="text-sm flex-shrink-0 flex-grow-0"
                style="
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            "
              >
                <span
                  style="font-size:12px;font-weight: 400;
color: #000000;"
                >
                  {{ item.goodsInfoName }}</span
                >
              </div>

              <!-- //价格 -->
              <div>
                <span>x</span><span class="">{{ item.qty }}</span>
              </div>
              <!-- 底部 -->
              <div class="flex justify-between items-center">
                <!-- 底部最左侧 -->
                <div class="flex items-center flex-shrink-0">
                  <div
                    class="font-xxxs"
                    style="
                  width: 5rem;
                  display: inline-block;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
                  >
                    {{ item.spec || null }}
                  </div>
                </div>
                <!-- 底部最右侧 -->
                <div class="flex flex-row items-center flex-shrink-0">
                  <div class="flex items-center mr-1 statusOneImg">
                    {{ source.state | status_f(returnOrderState) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 有多个图片的 -->
        <div
          v-else
          :class="{ manyImglistContant: source.orderItems.length > 1 }"
        >
          <div class="img-list">
            <div
              v-for="(item, index) in source.orderItems"
              :key="source.orderNo + index"
              v-show="index < 3"
              class="img"
              :style="{
                backgroundImage: 'url(' + item.imgUrl + ')',
              }"
            ></div>
            <div class="more" v-show="source.orderItems.length > 3">…</div>
          </div>
          <div class="status">
            <div class="value">
              {{ source.state | status_f(returnOrderState) }}
            </div>
            <div class="count">共{{ source.orderItemTotal }}种</div>
          </div>
        </div>
      </div>
      <div class="bottom van-hairline--top">
        <div class="detail">
          <div class="amount">
            ¥&nbsp;{{ source.paidAmount | amount
            }}<span>预计可赚：{{ source.expectCommission }}</span>
          </div>
          <div class="time">
            退单时间：{{ dayjs(source.createTime).format('YYYY/MM/DD HH:mm') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    source: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      returnOrderState: (state) => state.options.returnOrderState,
    }),
  },
  filters: {
    status_f(val, list) {
      const i = list.find((item) => item.value === val)
      return (i && i.label) || ''
    },
  },
}
</script>

<style lang="less" scoped>
.after-sale-item {
  padding: 24px 24px 0;
  .item {
    background: #ffffff;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    .head {
      font-size: 24px;
      color: #666666;
      line-height: 34px;
      padding: 28px 36px 26px;
    }
    .body {
      display: flex;
      justify-content: space-between;
      padding: 38px 32px 28px;
      .img-list {
        display: flex;
        align-items: flex-end;
        .img {
          width: 132px;
          height: 132px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          margin-right: 12px;
        }
        .more {
          font-size: 34px;
          color: #999999;
          line-height: 48px;
        }
      }
      .status {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        .value {
          font-size: 28px;
          line-height: 28px;
        }
        .count {
          font-size: 24px;
          color: #999999;
          line-height: 24px;
        }
      }
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding: 28px 32px 28px 36px;
      .detail {
        font-size: 28px;
        line-height: 28px;
        .amount {
          span {
            color: red;
            padding-left: 16px;
          }
        }
        .time {
          padding-top: 28px;
        }
      }
      .btn {
        background: #e82035;
        color: #fff;
        padding: 12px 24px;
        border-radius: 48px;
        font-size: 24px;
        line-height: 24px;
      }
    }
  }
}

.manyImglistContant {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.statusOneImg {
  font-size: 28px;
  line-height: 28px;
}
</style>
